import { Currency } from '../billing/billing.types';
import { PaymentTermCode } from '../members/members.types';

export type PaymentRecordDetailActionTypes =
  'GET_PAYMENT_RECORD_DETAIL' | 'GET_PAYMENT_RECORD_DETAIL_PENDING' | 'GET_PAYMENT_RECORD_DETAIL_FULFILLED' |
  'GET_PAYMENT_RECORD_DETAIL_REJECTED' |
  'REQUEST_COLLECTION' | 'REQUEST_COLLECTION_PENDING' | 'REQUEST_COLLECTION_FULFILLED' |
  'REQUEST_COLLECTION_REJECTED' |
  'RETRY_FAILED_PAYMENT' | 'RETRY_FAILED_PAYMENT_PENDING' | 'RETRY_FAILED_PAYMENT_FULFILLED' |
  'RETRY_FAILED_PAYMENT_REJECTED' |
  'GET_PAYMENT_LIST' | 'GET_PAYMENT_LIST_PENDING' | 'GET_PAYMENT_LIST_FULFILLED' | 'GET_PAYMENT_LIST_REJECTED' |
  'GET_PAYMENT_DETAILS' | 'GET_PAYMENT_DETAILS_PENDING' | 'GET_PAYMENT_DETAILS_FULFILLED' | 
  'GET_PAYMENT_DETAILS_REJECTED' | 'RIDIRECT_FROM_MEMBER' | 'REMOVE_RIDIRECT_FROM_MEMBER' |
  'REMOVE_PAYMENT_DETAILS' |
  'REVERT_TO_INITIAL_STATE' | 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH';

export type PaymentsState = {
  statusCode: number
  paymentRecordDetails: Array<PaymentRecordDetail>
  paymentList: Payment[]
  paymentDetails?: any
  fromMemberComponent?: any
};

export type PaymentMethodType = 'CASH' | 'VOIDCHEQUE' | 'CREDITCARD';

export type PaymentRecordDetail = {
  readonly collectionStatus: CollectionStatus
  readonly memberName: string
  readonly memberId: number
  readonly payerId: number
  readonly payerName: string
  readonly amount: number
  readonly paymentStatus: PaymentStatus
  readonly chargeDate: number
  readonly numberOfTransactions: number
  readonly remainingTransactions: number
  readonly description: string
  readonly downPayment: number
  readonly remainingBalance: number
  readonly total: number
  readonly paymentHistoryId: number
  readonly paymentMethodType: PaymentMethodType
  readonly tags: string[]
  readonly programNames: string[]
};

export type FailedPaymentRequest = {
  readonly paymentCode: number
  readonly email: string
  readonly cardNumber: string
  readonly cardHolderName: string
  readonly cvc: string
  readonly expiryMonth: string
  readonly expiryYear: string
  readonly country: string
};

export type CollectionStatus = 'NOT_REQUESTED' | 'REQUESTED' | 'IN_PROGRESS' | 'CLOSED' | 'COLLECTED';

export type Payment = {
  readonly id: number
  readonly payerId: number
  readonly paymentType: string
  readonly memberId: number
  readonly paymentMethodId: number
  readonly amountPerTransaction: number
  readonly currency: Currency
  readonly startDate: number
  readonly numberOfTransactions: number
  readonly term: PaymentTermCode
  readonly continuous: boolean
  readonly active: boolean
  readonly description: string
};

export type PaymentRecordDetailsResponse = {
  msg: string
  paymentRecordDetails: Array<PaymentRecordDetail>
  paymentHistoryId: number
  list: Payment[]
  entity: any
};

export const initialPaymentsState = {
  statusCode: 0,
  paymentRecordDetails: [],
  paymentList: []
};

export type PaymentStatus = 'SCHEDULED' | 'FAILED' | 'SUCCEEDED' | 'SUBMITTED' | 'RETURNED';

export type CreditCardType =
  'NONE' |
  'VISA' |
  'MASTERCARD' |
  'AMEX' |
  'DINERS CLUB' |
  'DISCOVER' |
  'UNIONPAY' |
  'JCB' |
  'VISA ELECTRON' |
  'MAESTRO' |
  'FORBRUGSFORENINGEN' |
  'DANKORT';



// WEBPACK FOOTER //
// ./src/payments/Types.tsx